itsoftApp.createModule("videoAutoplay", function () {
    const module = this;
    const firstAutoplay = document.querySelector(".js-first-autoplay");

    const videoInit = function (video) {
        const onVideoPlay = function () {
            video.removeEventListener('canplaythrough', onVideoPlay);
            DEBUG && console.log('Видео готово к воспроизведению. Можно запускать!');

            video.play().catch(error => {
                console.log("Автозапуск все еще заблокирован:", error);
            });
        };

        if (video) {
            video.muted = true; // Обязательно выключаем звук
            video.playsInline = true;

            if (!video.classList.contains("js-no-loop")) {
                video.autoplay = true;
                video.loop = true;
            }

            // if (video.classList.contains("js-nodownload")) {
            //     video.setAttribute("controlslist", "nodownload");
            // }

            // document.addEventListener('touchstart', () => {
            //     video.play();
            // }, { once: true });

            onVideoPlay();

            if (video.readyState >= 4) {
                onVideoPlay();
                DEBUG && console.log("Видео уже можно запускать");
            } else {
                video.addEventListener('canplaythrough');
            }

            // video.addEventListener('canplaythrough', onVideoPlay);
        }
    }

    if (firstAutoplay) {
        itsoftApp.modules.pageLoad.addEvent(function () {
            // setTimeout(function () {
                videoInit(firstAutoplay);
            // }, 300);
        });
    }

    module.init = videoInit;
});